import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

const ShradhdhaServicePage = () => {
  const images = [
    '/images/shradham/shradha-things-required1.jpg',
    '/images/shradham/shradha-things.jpg',
    '/images/shradham/things-for-shradham.jpg',
    '/images/shradham/20170105_100721.jpg',
    '/images/shradham/20170105_100733.jpg',
    '/images/shradham/shradham-new-1.jpg',
    '/images/shradham/shradham-new-2.jpg',
    '/images/shradham/shradham-new-3.jpg',
    '/images/shradham/shradham-new-4.jpg',
    '/images/shradham/shradham-new-5.jpg'
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <div className="bg-orange-50 min-h-screen pb-16">
      <Helmet>
        <title>சிறப்பான ச்ராத்த சேவைகள் | ஸ்ரீ வைஷ்ணவ கேந்திரம் | Ahobilam.com</title>
        <meta name="description" content="சாஸ்திர முறைப்படி ஸ்ரீ வைஷ்ணவர்களுக்கு மிகச் சிறப்பான முறையில் வாத்யார், ஸ்வாமிகள், தளிகை, இடம் உட்பட அனைத்தும் ரூ.10,000 முதல் செய்து கொடுக்கிறோம். வெளிநாடு வாழ் இந்தியர்களுக்கு (NRI) வீடியோ கால் வசதி." />
        <meta name="keywords" content="Shradhdha service, Vaideekam, Sri Vaishnava Kendram, Video Call Shradhdham, USA NRI Shradhdham, Purohit services Chennai" />
      </Helmet>

      {/* Hero Section */}
      <div className="relative bg-orange-900 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img 
            src="/images/shradham/shradha-things-required1.jpg" 
            alt="Background" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-16 md:py-24 text-center">
          <div role="heading" aria-level="1" className="text-xl md:text-5xl font-bold mb-6 text-yellow-300 drop-shadow-md">
            ஸ்ரீ வைஷ்ணவ கேந்திரம் - வைதீக ஸ்தாபனம்
          </div>
          <div role="heading" aria-level="2" className="text-lg md:text-3xl font-semibold mb-8 text-white drop-shadow-sm">
            சாஸ்திர முறைப்படி மிகச் சிறப்பான ச்ராத்த சேவைகள்
          </div>
          <div className="bg-orange-800/80 inline-block px-6 py-3 rounded-full border border-yellow-500 shadow-xl">
            <p className="text-base md:text-xl font-bold text-yellow-200">
              ரூ. 10,000 முதல் ஆரம்பம்
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Main Content */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border-t-4 border-orange-500">
            <div role="heading" aria-level="3" className="text-xl md:text-2xl font-bold text-orange-800 mb-6 border-b-2 border-orange-100 pb-4">
              நமது சிறப்புச் சேவைகள்
            </div>
            
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-6 text-justify">
              நாம் நம்முடைய <strong>ஸ்ரீ வைஷ்ணவ கேந்திரம் - வைதீக ஸ்தாபனத்தில்</strong> சாஸ்திர முறைப்படி ஸ்ரீ வைஷ்ணவர்களுக்கு மிகச் சிறப்பான முறையில் ச்ராத்தங்களை நிறைவேற்றித் தருகிறோம். 
            </p>

            <ul className="space-y-4 mb-8">
              <li className="flex items-start">
                <span className="text-green-600 mr-3 text-lg md:text-xl">✓</span>
                <span className="text-gray-800 text-sm md:text-base">
                  <strong>முழுமையான ஏற்பாடு:</strong> தரமான பொருட்களுடன் வாத்யார், ஸ்வாமிகள், தளிகை மற்றும் இடம் என அனைத்தும் உள்ளடங்கியது.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-green-600 mr-3 text-lg md:text-xl">✓</span>
                <span className="text-gray-800 text-sm md:text-base">
                  <strong>கட்டணம்:</strong> நிறைவான சேவை, ரூபாய் 10,000 முதல் தொடங்குகிறது.
                </span>
              </li>
              <li className="flex items-start bg-orange-50 p-4 rounded-lg border border-orange-200 mt-4">
                <span className="text-orange-600 mr-3 text-xl md:text-2xl">🌍</span>
                <span className="text-gray-900 text-sm md:text-base">
                  <strong>வெளிநாடு வாழ் இந்தியர்களுக்கான (NRI) சிறப்பு வசதி:</strong><br/>
                  அமெரிக்கா உள்ளிட்ட வெளிநாடுகளில் வசிப்போருக்கு, அவர்கள் வீடியோ மூலம் மந்திரம் மட்டும் அங்கிருந்து சொல்ல - ஸ்வாமிகள், போஜனம் முதலியவை இங்கிருந்து <strong>வீடியோ கால் (Video Call)</strong> மூலம் மிகச் சிறப்பாக நடத்திக் கொடுக்கிறோம்.
                </span>
              </li>
            </ul>

            <div className="text-center mt-8">
              <a 
                href="https://wa.me/918610736302" 
                target="_blank" 
                rel="noreferrer"
                className="inline-block bg-green-600 hover:bg-green-700 text-white text-xl font-bold py-4 px-8 rounded-full shadow-lg transform transition hover:scale-105"
              >
                வாட்ஸ்அப் மூலம் தொடர்புகொள்ள
              </a>
              <p className="mt-4 text-gray-500 font-medium">அல்லது அழையுங்கள்: +91 86107 36302</p>
            </div>
          </div>

          {/* Slideshow Gallery */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[400px] md:h-[500px] bg-gray-900 group">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Shradhdha Service ${index + 1}`}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
              />
            ))}
            
            {/* Gallery Overlay */}
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-6 text-white">
              <p className="text-lg font-medium drop-shadow-md">
                தரமான பொருட்கள் மற்றும் தூய்மையான இடம்
              </p>
            </div>

            {/* Slideshow Controls */}
            <div className="absolute inset-y-0 left-0 flex items-center">
              <button 
                onClick={() => setCurrentSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1))}
                className="bg-black/50 hover:bg-black/80 text-white p-2 rounded-r-lg opacity-0 group-hover:opacity-100 transition"
              >
                ◀
              </button>
            </div>
            <div className="absolute inset-y-0 right-0 flex items-center">
              <button 
                onClick={() => setCurrentSlide((prev) => (prev + 1) % images.length)}
                className="bg-black/50 hover:bg-black/80 text-white p-2 rounded-l-lg opacity-0 group-hover:opacity-100 transition"
              >
                ▶
              </button>
            </div>
          </div>
          
        </div>
      </div>
      
      {/* Bottom CTA Banner */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16">
        <div className="bg-gradient-to-r from-orange-600 to-red-700 rounded-2xl p-8 md:p-12 text-center shadow-2xl text-white">
          <div role="heading" aria-level="2" className="text-xl md:text-3xl font-bold mb-4 text-white">உங்கள் பித்ரு கடமைகளை குறையின்றி நிறைவேற்றுங்கள்</div>
          <p className="text-base md:text-lg mb-8 opacity-90">முன்பதிவு செய்ய மற்றும் மேலும் விவரங்களுக்கு எங்களை அணுகவும்.</p>
          <a 
            href="/contact?service=shradhdham" 
            className="inline-block bg-white text-orange-700 text-base md:text-xl font-bold py-3 md:py-4 px-8 md:px-10 rounded-full shadow-lg transform transition hover:scale-105 hover:bg-yellow-50"
          >
            தொடர்புகொள்ள (Contact Us)
          </a>
        </div>
      </div>

    </div>
  );
};

export default ShradhdhaServicePage;
